import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-selector-dialog',
  templateUrl: './selector-dialog.component.html',
  styleUrl: './selector-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatSelect, FormsModule, MatOption, MatDialogActions, MatButton],
})
export class SelectorDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<SelectorDialogComponent>>(MatDialogRef);
  data = inject<SelectorDialogData>(MAT_DIALOG_DATA);

  value: any = null;

  ngOnInit(): void {
    const initial = this.data.initial_selected_values;
    if (Array.isArray(initial) && initial.length > 0) {
      const first = initial[0];
      this.value = first != null && typeof first === 'object' && 'value' in first ? first.value : first;
    }
  }

  submit() {
    this.dialogRef.close(this.value);
  }

  close() {
    this.dialogRef.close();
  }
}

export interface SelectorDialogData {
  dialog_title: string;
  dialog_subtitle?: string;
  dialog_ok_button: string;
  dialog_cancel_button: string;
  data: SelectorDialogDataRow[];
  initial_selected_values?: any[];
}

export interface SelectorDialogDataRow {
  value: any;
  textToShow: string;
  disabled?: boolean;
}
